export default {
    name: 'Quitt',
    import: function () { return import('./index'); },
};
